import React, { useEffect, useState } from "react";
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';

import { 
    GuestListTableContainer, 
} from './../owner/owner.style';
import { gql,useQuery } from '@apollo/client';
import {
    TableHead,
    TableBodyRow
} from '../../../../widget/styledComponents/table.style'
import Cookies from 'js-cookie';
import {   IconButton, MoreIcon, Pagination, Spinner, } from 'evergreen-ui'
import AddPropertyBtn from "./widget/add_property";
import PropertyDetailsPageWidget from "./propertyDetailsPageWidget";
import AddAssetsPlaceholder from "../../../../widget/add_assets_placeholder";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setNextPageId } from "../../../../../state/actions";
// import { setNextPageId } from './actions';


export const FETCH_PROPERTY_LIST = gql`
query Properties_getByFacility($facilityId: ID!, $pagination: PaginationInput!) {
  properties_getByFacility(facilityId: $facilityId, pagination: $pagination) {
    _id
    facility
    type
    address
    numberOfRooms
    squareMeter
    createdAt
    owner {
      _id
      id
      email
      name
      phone
      photo
      facility
      isAccountActivated
      createdAt
    }
    resident {
      _id
      email
      name
      phone
      photo
      facility
      id
      isAccountActivated
      createdAt
    }
  }
}
`;

function PropertyPageWidget() {
const nextPageId = useSelector((state) => state.nextPageId);
// const prevPageId = useSelector((state) => state.prevPageId);
const dispatch = useDispatch();

const facilityId = Cookies.get('facilityId');
const [currentPage, setCurrentPage] = useState(null);
const { loading,data,refetch }  = useQuery(FETCH_PROPERTY_LIST,{
    variables: {
        facilityId:facilityId,
        pagination: {
            cursor: currentPage,
            limit: 1000
        },
     },
});

const [showPropertyDetails,setShowPropertyDetails] = useState(false)
const [showPropertyDetailsData,setShowPropertyDetailsData] = useState(null)




const nextPage = (count) => {
  // setCurrentPage(currentPage + 1);
  handleUpdate()
  fetchData(count);
};

const prevPage = () => {
  setCurrentPage(currentPage - 1);
};
const pageChange = (e)=>{
  setCurrentPage(e);
  fetchData()
  console.log(currentPage)
}

const fetchData = async (pageCOunt) => {
    await refetch({
        facilityId: facilityId,
        pagination: {
            cursor: nextPageId,
            limit: pageCOunt
        }
    });
    // setCurrentPage(page);
};

const handleUpdate = (id) => {
  dispatch(setNextPageId(id)); // Example: Update nextPageId to 2
};

useEffect(() => {
  if (data && data.properties_getByFacility.length > 0) {
      const lastPropertyId = data.properties_getByFacility[data.properties_getByFacility.length - 1]._id;
      dispatch(setNextPageId(lastPropertyId));
  }
}, [data, dispatch]);
  return (
    <div>
    {showPropertyDetails &&
      <div>
         <br/><br/>
          <div className='row'>
              <div className='col s12 ' style={{
                display:"flex"
              }}>
                  <span className='center' style={{
                        width:"30px",
                        height:"30px",
                        cursor: "pointer"
                    }}
                        onClick={()=>setShowPropertyDetails(false) }

                    >
                        <i className='material-icons center'>arrow_backwards</i>
                    </span>
                  <PageTitleText>
                    Units
                  </PageTitleText>
              </div>
              
          </div>
          <PropertyDetailsPageWidget data={showPropertyDetailsData} />
      </div>
    }

     {!showPropertyDetails &&
      <div className=''>
          <br/><br/>
          <div className='row'>
              <div className='col s12 m3'>
                  <PageTitleText>
                    Units
                  </PageTitleText>
              </div>
              
          </div>  

          <AddPropertyBtn facilityId={facilityId}/>
          {/* <div>Next Page ID: {nextPageId}<br/>Prev :{prevPageId}</div>; */}
          <GuestListTableContainer>
             
              <table className='responsive-table'>
                  <thead>
                  <tr
                  >
                      <TableHead>Address</TableHead>
                      <TableHead>Owner</TableHead>
                      <TableHead>Type</TableHead>
                      <TableHead>Resident</TableHead>
                      {/* <TableHead>Actions</TableHead> */}
                      <TableHead>
                        {/* <MoreIcon /> */}
                        More
                      </TableHead>

                  </tr>
                  </thead>

                  <tbody>
                      {loading && <Spinner/> }
                      {data &&
                      
                      data.properties_getByFacility.map((data) => 
                          <TableBodyRow 
                            // onClick={()=>console.log(data._id)}
                            onClick={()=>{
                              setShowPropertyDetails(true)
                              setShowPropertyDetailsData(data)
                            }}
                          >
                              <td>{data.address}</td>
                              {data.owner &&
                                <td>{data.owner.name}</td>
                              }
                              {!data.owner &&
                                <td>--</td>
                              }
                              <td>{data.type}</td>
                              {data.resident &&
                                <td>{data.resident.name}</td>
                              } 
                              {!data.resident &&
                                <td>--</td>
                              }
                              {/* <td>
                                <DeleteProperty id={data._id} />
                              </td> */}
                              <td>
                                <IconButton 
                                   onClick={()=>{
                                    setShowPropertyDetails(true)
                                    setShowPropertyDetailsData(data)
                                  }}
                                icon={MoreIcon} intent="primary"  />
                                
                              </td>
                            
                          </TableBodyRow>
                          )
                      }
                    
                  </tbody>
                  
              </table>
              <center>
                <AddAssetsPlaceholder/>
              </center>
              <Pagination className='transparent z-depth-0' page={currentPage} totalPages={1} 
                onPageChange={(e)=>pageChange(e)}
                onNextPage={(e)=>nextPage(100)}
                onPreviousPage={(e)=>prevPage()}
              ></Pagination>             
          </GuestListTableContainer>
      </div>
      }
    </div>
  )
}

export default PropertyPageWidget
















